export default __webpack_public_path__ + "static/media/7c12c460610f8436f55eb40b693abb52.svg";